import { render, staticRenderFns } from "./ProductBundleSidebarElement.vue?vue&type=template&id=2de86ff6&scoped=true&"
import script from "./ProductBundleSidebarElement.vue?vue&type=script&lang=js&"
export * from "./ProductBundleSidebarElement.vue?vue&type=script&lang=js&"
import style0 from "./ProductBundleSidebarElement.vue?vue&type=style&index=0&id=2de86ff6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de86ff6",
  null
  
)

export default component.exports